import { render } from "./ck-editor.vue?vue&type=template&id=39466c7e"
import script from "./ck-editor.vue?vue&type=script&lang=js"
export * from "./ck-editor.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/components/form/ck-editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39466c7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39466c7e', __exports__)) {
    console.log('reload')
    api.reload('39466c7e', __exports__)
  }
  
  module.hot.accept("./ck-editor.vue?vue&type=template&id=39466c7e", () => {
    console.log('re-render')
    api.rerender('39466c7e', render)
  })

}


export default __exports__